const actions = {
  REQUESTING: 'Contracts/REQUESTING',
  RESPONSE_ERROR: 'Contracts/RESPONSE_ERROR',

  FETCH_CONTRACTS: 'Contracts/FETCH',
  LIST_CONTRACT: 'Contract/LIST',

  FETCH_CONTRACT: 'Contract/FETCH',
  NEW_CONTRACT: 'Contract/NEW',
  EDIT_CONTRACT: 'Contract/EDIT',
  RESET_CONTRACT: 'Contract/RESET',

  RE_FETCH_CONTRACTS: 'Contracts/REFRESH',
  SAVE_CONTRACT: 'Contract/SAVE',
  SAVE_CONTRACT_RECIEVED: 'Contract/SAVE_CONTRACT_RECIEVED',

  DELETE_CONTRACT: 'Contract/DELETE',
  DELETE_CONTRACT_RECIEVED: 'Contract/DELETE_RECIEVED',

  OPEN_COPY_CONTRACT: 'Contract/OPEN_COPY',
  CLOSE_COPY_CONTRACT: 'Contract/CLOSE_COPY',
  COPY_CONTRACT: 'Contract/COPY',
  COPY_CONTRACT_RECIEVED: 'Contract/COPY_RECIEVED',

  SELECT_CONTRACT: 'SELECT_CONTRACT',

  UNSELECT_CONTRACT: 'UNSELECT_CONTRACT',
  UNSELECT_CONTRACT_RECIEVED: 'UNSELECT_CONTRACT_RECIEVED',

  CHOOSE_CONTRACT: 'CHOOSE_CONTRACT',
  // Select the project a record belongs to and reload the page (contract mismatch).
  SWITCH_CONTRACT: 'Contract/SWITCH',
}

export default actions
